import { useFormik } from "formik";
import React from "react";
import { Col, Container, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import SpinnerButton from "../../components/Button";
import TicketZoneSelector from "../../components/TicketZoneSelector";

const MotivoModal = ({ toggle, ticket, isSavingTicket, handleTicketSave }) => {
  const formik = useFormik({
    initialValues: {
      asignacion2: ticket.asignacion2,
      sucursaldepartamentoAsignado: ticket.sucursaldepartamentoAsignado,
      motivo: ticket.motivo2,
      submotivo: ticket.submotivo,
    },
    onSubmit: async (data) => {
      formik.setSubmitting(true);
      try {
        await handleTicketSave(data, { formik });
        // eslint-disable-next-line no-empty
      } catch (err) {}
      formik.setSubmitting(false);
    },
    validationSchema: Yup.object().shape({
      motivo: Yup.number().typeError("Debe seleccionar un motivo de la lista").required("Este campo es requerido."),
      submotivo: Yup.number().typeError("Debe seleccionar un sub motivo de la lista").required("Este campo es requerido."),
    }),
  });

  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <Form onSubmit={formik.handleSubmit}>
        <ModalHeader toggle={toggle}> Motivo </ModalHeader>
        <ModalBody>
          <Container fluid>
            <Row>
              <Col className="h-100">
                <TicketZoneSelector formik={formik} typeMotivo />
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <FormGroup className="mb-0 px-3">
            <SpinnerButton className="btn btn-primary btn-block" isLoading={isSavingTicket} disabled={isSavingTicket} type="submit">
              Guardar
            </SpinnerButton>
          </FormGroup>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default MotivoModal;
